

export const PLATFORM = Object.freeze({
    WEB: "web",
    MOBILE: "mobile",
    CLI:"cli",
    MAC:"mac",
    WINDOWS:"windows"
});